import axios, { AxiosRequestConfig } from "axios";
import { toast } from "react-toastify";
import { EntEventsLogType, SettingsProjectType } from "src/Types";
import { NotificationMessage } from "src/components/Notification/NotificationMessage";

const DEFAULT_LOGOUT_URL = "/login";
const BANNED_STATUS = 403;

export enum LogLevelTypes {
	INFO = 1,
	DEBUG = 2,
	WARNING = 3,
	ERROR = 4
};

class API {

	/** Деавторизация с переадресацией */
	static signOut = ( logoutUrl: string = DEFAULT_LOGOUT_URL ) => {
		localStorage.removeItem('token');
		localStorage.removeItem('username');
		localStorage.removeItem('groups');
		localStorage.removeItem('passwordreset');
		localStorage.removeItem('profile');
		window.location.assign(logoutUrl);
	};

	/**
	 * Запись в лог-журнал
	 * @param objectName Кто вызвал
	 * @param senderID его ИД
	 * @param message сообщение
	 * @param logLevel тип лога
	 * @param data дополнительные данные
	 */
	static writeLog( objectName: string = 'RdevService', senderID: string = '-', message: string, logLevel: LogLevelTypes, otherParam: any ) {

		switch (logLevel) {
			case 1:
			case 2:
				console.log(message, otherParam);
				break;
			case 3:
				console.warn(message, otherParam);
				break
			case 4:
				console.error(message, otherParam);
				break;
			default:
				console.log(message, otherParam);
				break;
		}

		const data = {
			objectname: objectName,
			objectid: senderID,
			message: message ? message.toString() : '',
			data: !!otherParam ? JSON.stringify(otherParam) : "",
			eventtype: logLevel,
			closed: false
		};
		this._baseRequest({ url: "/events/createlog", method: "POST", data });
	};

	/**
	 * Создает уведомление
	 * @param isSuccess True - Удачное ( положительное ), иначе красное сообщение ошибки
	 * @param message Сообщение
	 * @param additionData Доп. данные
	 */
	static createNotify = ( isSuccess: boolean, message: string, additionData?: any ) => {
		const toastId = this._generateId();
		const toastOptions = {
			className: isSuccess ? "bg-success " : "bg-danger",
			toastId: toastId,
			position: toast.POSITION.BOTTOM_RIGHT,
			autoClose: 5000,
			closeOnClick: false,
			pauseOnFocusLoss: false,
			draggable: false
		};
		const content = NotificationMessage({
			toastId,
			isSuccess, 
			dateTime: new Date(Date.now()),
			message: message ? message.toString() : '',
			additionData
		});
		const func = isSuccess ? 'success' : 'error';
		toast[func](content, toastOptions);
	};

	///////////////////////// <Logs> //////////////////////////////////////////////////////

	/** Запрос на получения списка уведомлений */
	static getLogs = ( top: number = 20 ) => this._baseRequest<EntEventsLogType[]>({ url: "/events/getlogs/" + top });
	/** Скрывает лог */
	static hideLog = ( recid: string ) => this._baseRequest<boolean>({ url: "/events/hidelog/" + recid, method: "POST" });

	///////////////////////// </Logs> //////////////////////////////////////////////////////

	/** Запрос на получение настроек ПФ */
	static getPF_Settings = () => this._baseRequest<SettingsProjectType>( { url: "/settings/getsettings" } );

	/** Запрос за переменными окружения  */
	static getEnvironmentVariables = ( uncashed: boolean = false ) => this._baseRequest<Record<string, any>>({ 
		url: "/api/variables" + ( uncashed ? "?_t=" + Date.now() : "" )
	});

	////////////// PRIVATE ///////////////////////////////////////////////////

	/** Базовый запрос с предварительными ласками */
	static _baseRequest = async <T = null>( config: AxiosRequestConfig ): Promise<T|undefined> => {
		try {
			const cfg = {
				...config,
				headers: {
					...config.headers,
					Authorization: `Bearer ${localStorage.getItem('token')}`
				}
			};
			const response = await axios.request( cfg );
			if ( response.status === BANNED_STATUS ) {
				this.signOut();
			}
			return response.data;
		}
		catch ( error: any ) {
			console.groupCollapsed( "Ошибка при выполнении запроса" );
			console.log( "Адрес - ", config.url );
			console.warn( error.message );
			console.warn( error );
			console.groupEnd();
		}
	};

	/** Идентификатор для функции createNotify(isSuccess, message, additionData) */
	static _generateId = () => "id" + Math.random().toString(16).slice(2);
};

export default API;
